<template>
  <v-layout justify-space-around wrap row>
    <v-flex xs12 sm4 scrollDesign style="max-height: 55vh">
      <v-slide-x-transition mode="out-in">
        <v-list subheader two-line>
          <v-subheader key="subheader">
            {{ $t('surveys.create_survey.collaborators') }}
          </v-subheader>
          <draggable
            :list="list"
            group="elements"
            class="list-group"
            draggable=".item"
          >
            <v-slide-y-transition class="two-line subheader" group>
              <v-list-tile
                avatar
                class="pa-2 mb-3 elevation-1 grey lighten-5 list-group-item item"
                style="border-radius: 5px"
                v-for="element in list"
                :key="element.id"
              >
                <v-list-tile-avatar>
                  <v-img
                    :src="require('@/assets/panel/home/SKLB-Niveles.png')"
                  ></v-img>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="element.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-slide-y-transition>
          </draggable>
        </v-list>
      </v-slide-x-transition>
    </v-flex>
    <v-flex xs6>
      <v-list subheader>
        <v-subheader key="subheader">
          {{ $t('surveys.create_survey.added_collaborators') }}
        </v-subheader>
        <draggable
          group="elements"
          class="list-group"
          :list="selectedList"
          draggable=".item"
        >
          <v-slide-y-transition class="two-line subheader" group>
            <v-list-tile
              avatar
              class="pa-2 mb-3 elevation-1 grey lighten-5 list-group-item item"
              style="border-radius: 5px"
              v-for="element in selectedList"
              :key="element.id"
            >
              <v-list-tile-avatar>
                <v-img
                  :src="require('@/assets/panel/home/SKLB-Niveles.png')"
                ></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="element.name"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              avatar
              class="pa-2 mb-3 list-group-item item"
              style="border-radius: 5px"
              :key="0"
            >
              <v-list-tile-avatar>
                <v-icon color="primary" large>add</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ $t('surveys.create_survey.drag_collaborators') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-slide-y-transition>
        </draggable>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
  },
  props: ['array', 'value'],
  watch: {
    array() {
      this.list = this.array
    },
    value() {
      this.selectedList = this.value
    },
    selectedList() {
      this.$emit('input', this.selectedList)
    },
  },
  mounted() {
    this.list = this.array
    this.selectedList = this.value

    if (this.selectedList != '') {
      let selectedListID = this.selectedList.map((sg) => sg.id)
      this.list = this.list.filter((ob) => ob.id != selectedListID)

      for (let index = 0; index < this.selectedList.length; index++) {
        for (let index1 = 0; index1 < this.list.length; index1++) {
          if (this.selectedList[index].id == this.list[index1].id) {
            this.list.splice(index1, 1)
            index1--
            console.log('1')
          }
        }
      }
    } else {
    }
    this.$forceUpdate()
  },
  data: () => ({
    list: [],
    selectedList: [],
  }),
}
</script>

<style></style>
